var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPhone = function SvgPhone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .2v31.6c0 .11.09.2.2.2h19.6a.2.2 0 0 0 .2-.2V.2a.2.2 0 0 0-.2-.2H6.2a.2.2 0 0 0-.2.2m18 2v19.6a.2.2 0 0 1-.2.2H8.2a.2.2 0 0 1-.2-.2V2.2c0-.11.09-.2.2-.2h15.6c.11 0 .2.09.2.2M8 29.8v-5.6c0-.11.09-.2.2-.2h15.6c.11 0 .2.09.2.2v5.6a.2.2 0 0 1-.2.2H8.2a.2.2 0 0 1-.2-.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 28h3.6a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2h-3.6a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2"
  })));
};
export default SvgPhone;